import './index.scss';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { List, ListItem } from '@material-ui/core';
import { DeleteController } from './Controllers/DeleteController';
import { DownloadController } from './Controllers/DownloadController';
import { SaveAsController } from './Controllers/SaveAsController';
import { SaveController } from './Controllers/SaveController';
import { EditTextFieldContainer } from './EditTextFieldContainer';
import { DetailsInfo } from '@components/SharedComponents/DetailsInfo';
import { translate } from '@utils';
import {
  canCreateSubmissionSelector,
  canDownloadSubmissionSelector,
  canRemoveSubmissionsSelector,
  canUpdateSubmissionSelector,
  currentSubmissionIsSampleSelector,
  currentSubmissionSelector,
  submissionsSelector,
} from '@selectors/submission';

export const Controllers = () => {
  const currentSubmission = useSelector(currentSubmissionSelector);
  const submissions = useSelector(submissionsSelector);

  const canCreate = useSelector(canCreateSubmissionSelector);
  const canUpdate = useSelector(canUpdateSubmissionSelector);
  const canDownload = useSelector(canDownloadSubmissionSelector);
  const canRemove = useSelector(canRemoveSubmissionsSelector);
  const isSample = useSelector(currentSubmissionIsSampleSelector);

  const controllers = [
    {
      component: (
        <ListItem
          key="create"
          className="template-controllers-item"
          data-testid="save-as-controller-button"
        >
          <SaveAsController description={`${translate('save_template_as')}`} />
        </ListItem>
      ),
      isVisible: canCreate,
    },
    {
      component: (
        <ListItem
          key="update"
          className="template-controllers-item"
          data-testid="save-controller-button"
        >
          <SaveController description={`${translate('save_modal_template_name')}`} />
        </ListItem>
      ),
      isVisible: canUpdate,
    },
    {
      component: (
        <ListItem
          key="remove"
          className="template-controllers-item"
          data-testid="delete-controller-button"
        >
          <DeleteController description={`${translate('delete_modal_template_name')}`} />
        </ListItem>
      ),
      isVisible: canRemove,
    },
    {
      component: (
        <ListItem
          key="download"
          className="template-controllers-item"
          data-testid="download-controller-button"
        >
          <DownloadController description={isSample ? `${translate('download_sample')}` : `${translate('download_modal_template_name')}`} />
        </ListItem>
      ),
      isVisible: canDownload,
    },
  ];
  return (
    <div className="template-modals">
      {currentSubmission && !isEmpty(submissions) && (
        <div className="template__controllers_edit">
          <EditTextFieldContainer />
        </div>
      )}
      <div className="template__controllers">
        <List className="template__controllers_list button-box">
          {controllers.filter(({ isVisible }) => isVisible).map(({ component }) => component)}
        </List>
      </div>
      <div className="template__controllers_info">
        {currentSubmission && !currentSubmission.isSample && (
          <DetailsInfo submission={currentSubmission} />
        )}
      </div>
    </div>
  );
};
